import { render, staticRenderFns } from "./AdminPathwayCard.vue?vue&type=template&id=8ed78718"
import script from "./AdminPathwayCard.vue?vue&type=script&lang=js"
export * from "./AdminPathwayCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports